export default {
  updateSlotSwitcherIndex({ commit }, index) {
    commit('SET_SLOT_SWITCHER_INDEX', index)
  },
}
